import React, { useContext, useEffect, useState } from 'react';

import { TableCell, TableRow, Checkbox } from '@material-ui/core';

import { GlobalContext } from '../../../../../../../store';
import { IEventEnrollment } from '../../../../../../../store/admin/eventEnrollments/store';

import {
  useContestSetupDispatch,
  useContestSetupState
} from '../../../Context/ContestSetup.context';
import { useRouteInfoState } from '../../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { useAdminRound } from '../../../../../../../contrib/Hooks/useAdminRound.hook';
import { toHandicap } from '../../../../../../../contrib/Utils/toHandicap';

interface IContestSetupTableRowProps {
  enrollment: IEventEnrollment;
}

export const ContestSetupTableRow = (props: IContestSetupTableRowProps) => {
  const { enrollment } = props;

  const {
    actions: {
      loader: { start: startLoader, end: endLoader },
      notifications: { pushError }
    }
  } = useContext(GlobalContext);

  const { clubId, eventId, roundId } = useRouteInfoState();

  const {
    actions: { updateEnrollments }
  } = useContestSetupDispatch();

  const { selectedLeaderboard } = useContestSetupState();

  const [round] = useAdminRound(roundId);

  const [playerHandicap, setPlayerHandicap] = useState<number>();

  const isItemSelected = selectedLeaderboard
    ? selectedLeaderboard.enrollments.includes(enrollment.id)
    : false;

  const handleClick = (enrollmentId: number) => async (_: React.MouseEvent<unknown>) => {
    if (selectedLeaderboard) {
      const enrollments = selectedLeaderboard.enrollments;

      const newSelected = enrollments.includes(enrollmentId)
        ? enrollments.filter(id => id !== enrollmentId)
        : [...enrollments, enrollmentId];

      if (newSelected.length === 0) {
        pushError('Every contest must have at least one player registered');

        return;
      }

      startLoader();

      await updateEnrollments(
        Number(clubId),
        Number(eventId),
        Number(roundId),
        selectedLeaderboard.id,
        newSelected
      );

      endLoader();
    }
  };

  useEffect(() => {
    if (round && round.groups) {
      const games = round.groups.flatMap(group => group.games);

      const gameFound = games.find(roundGame => roundGame.enrollment === enrollment.id);

      if (gameFound) {
        setPlayerHandicap(gameFound.handicap);
      }
    }
  }, [round, enrollment.id]);

  return (
    <TableRow
      hover={true}
      onClick={handleClick(enrollment.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      selected={isItemSelected}
      classes={{ selected: 'row-selected', root: 'row-root' }}
    >
      <TableCell padding="checkbox">
        <Checkbox checked={isItemSelected} color="primary" />
      </TableCell>

      <TableCell scope="row" padding="none">
        {`${enrollment.user.firstName} ${enrollment.user.lastName}`}
      </TableCell>

      <TableCell align="center">{toHandicap(playerHandicap)}</TableCell>

      <TableCell align="left">{enrollment.flight ? enrollment.flight.name : ''}</TableCell>
    </TableRow>
  );
};
